import { render, staticRenderFns } from "./services.vue?vue&type=template&id=00c9f80f&"
import script from "./services.vue?vue&type=script&lang=ts&"
export * from "./services.vue?vue&type=script&lang=ts&"
import style0 from "./services.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports